// Algolia Search-only 클라이언트 (client-only 플러그인 — SSR에서는 절대 실행되지 않음)
//
// 프런트에는 Application ID / Search-only API Key / Index Name만 사용한다.
// Admin API Key, Extension 전용 쓰기 Key는 이 파일은 물론 어떤 프런트 코드에도 포함하지 않는다.
import type { LiteClient } from 'algoliasearch/lite'
import { liteClient } from 'algoliasearch/lite'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const { algoliaAppId, algoliaSearchKey } = config.public

  let client: LiteClient | null = null

  if (algoliaAppId && algoliaSearchKey) {
    client = liteClient(algoliaAppId, algoliaSearchKey)
  }
  else {
    // Algolia 환경변수가 아직 설정되지 않은 환경(로컬 등)에서도 앱이 죽지 않도록
    // 클라이언트를 주입하지 않는다. useSearchStore가 이 상태를 감지해 에러 상태로 안내한다.
    console.warn('[algolia] ALGOLIA_APP_ID / ALGOLIA_SEARCH_KEY가 설정되지 않아 검색 기능이 비활성화됩니다.')
  }

  return {
    provide: {
      algolia: client,
    },
  }
})
